var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    className: "share",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.561 5.939-5.5-5.5A1.5 1.5 0 0 0 9.5 1.5v2.523c-4.311.13-9.5.967-9.5 6.291a6.421 6.421 0 0 0 3.051 5.436 1.5 1.5 0 0 0 2.256-1.7c-.761-2.427-.388-3.729 4.193-4v2.45a1.5 1.5 0 0 0 2.561 1.061l5.5-5.5a1.5 1.5 0 0 0 0-2.122zM11 12.5v-4c-5.141.056-8.67 1.057-7.124 5.988A4.944 4.944 0 0 1 1.5 10.314C1.5 5.869 6.526 5.521 11 5.5v-4L16.5 7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.4c122a45.svg";
export { ForwardRef as ReactComponent };